import { render, staticRenderFns } from "./TelegramOtpGroupFilter.vue?vue&type=template&id=23d79725&"
import script from "./TelegramOtpGroupFilter.vue?vue&type=script&lang=ts&"
export * from "./TelegramOtpGroupFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports